import { FunctionFactory } from 'survey-core';
import { Equipment } from '../quiz/equipment';
import { getMotivationalByName } from './testimonials';
import { Gender } from '../quiz/gender';
import { getGenderKey } from '../features/utils';
import { Physiology } from '../quiz/physiology';
import { locHtml } from './locHtml';
import { makeSplashHeader } from './SplashHeader';

const equipmentSplashHtml = locHtml((t) => `
<div class="new-quote-container"> 
  <div class="splash-header">
    <h1>${t("splash.equipment.title")}</h1>
    <div class="quote">
      ${t("splash.equipment.text")}
    </div>
  </div>
  <div class="quote-img-container">
    <img src="{equipmentImgUrl}" alt="${t("splash.equipment.imageAlt")}" />
  </div>
  <div class="image-footnote">{equipmentTestimonialsDisplayName} - ${t("splash.realMember")}</div>
</div>`);

const equipmentSplashExpression = {
  name: "equipmentQuote",
  expression: "renderEquipmentQuote({equipment})",
};

function renderEquipmentQuote(params: any[]): string {
  if (params === undefined || params === null) return "";
  switch (params[0] as Equipment) {
    case Equipment.FullHomeGym:
    case Equipment.DumbellsOnly:
      return `Great! That's more than enough. We use science to get you incredible results regardless of what equipment you do or don't have.`;
    case Equipment.FullCommercialGym:
      return `Great! If you are ever limited on equipment (e.g. traveling) or want to consider working out at home, we'll give you alternative workouts that are just effective.`;
    default:
      return `Great! We'll take that into consideration. We use science to get you incredible results regardless of what equipment you do or don't have.`;
  }
}

FunctionFactory.Instance.register("renderEquipmentQuote", renderEquipmentQuote);

const equipmentSplashElement = {
  name: 'equipment-splash',
  type: 'html',
  html: equipmentSplashHtml,
}

function renderEquipmentImgUrl(params: any[]): string {
  if (params === undefined || params === null) return "";
  const gender = params[0] as Gender;
  const physiology = params[1] as Physiology;
  const genderKey = getGenderKey(gender, physiology);

  switch (genderKey) {
    case Gender.Female:
      return getMotivationalByName('Ligia').image;
    case Gender.Male:
      return getMotivationalByName('Jesse').image;
  }
}

const equipmentSplashImgUrlExpression = {
  name: "equipmentImgUrl",
  expression: "renderEquipmentImgUrl({gender}, {physiology})",
};

FunctionFactory.Instance.register("renderEquipmentImgUrl", renderEquipmentImgUrl);

const equipmentTestimonialsDisplayNameExpression = {
  name: "equipmentTestimonialsDisplayName",
  expression: "renderEquipmentTestimonialsDisplayName({gender}, {physiology})",
};

function renderEquipmentTestimonialsDisplayName(params: any[]): string {
  if (params === undefined || params === null) return "";
  const gender = params[0] as Gender;
  const physiology = params[1] as Physiology;
  const genderKey = getGenderKey(gender, physiology);

  switch (genderKey) {
    case Gender.Female:
      return getMotivationalByName('Ligia').displayName;
    case Gender.Male:
      return getMotivationalByName('Jesse').displayName;
  }
}

FunctionFactory.Instance.register("renderEquipmentTestimonialsDisplayName", renderEquipmentTestimonialsDisplayName);

const EquipmentSplashHeader = makeSplashHeader("splash.headers.equipment");

export {
  equipmentSplashElement,
  equipmentSplashExpression,
  equipmentSplashImgUrlExpression,
  equipmentTestimonialsDisplayNameExpression,
  EquipmentSplashHeader,
}